import React, { useState, useEffect } from 'react';
import styles from '../styles/LoginForm.module.css';

function LoginForm({ onLogin, isLoading }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  // Check if we're in development (localhost or 127.0.0.1)
  const isDevelopment = window.location.hostname.includes('localhost') ||
                        window.location.hostname.includes('127.0.0.1');

  useEffect(() => {
    // In production, redirect to OAuth immediately
    if (!isDevelopment && !isLoading) {
      // console.log('[LoginForm] Production detected - redirecting to OAuth');
      const apiUrl = process.env.REACT_APP_API_URL || '';
      window.location.href = `${apiUrl}/api/auth/oauth/initiate`;
    }
  }, [isDevelopment, isLoading]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!email) {
      setError('Email is required');
      return;
    }

    if (!password) {
      setError('Password is required');
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError('Please enter a valid email address');
      return;
    }

    // console.log('[LoginForm] Submitting login for:', email);
    try {
      await onLogin(email, password);
      // console.log('[LoginForm] Login successful');
    } catch (err) {
      console.error('[LoginForm] Login failed:', err);
      setError(err.message || 'Login failed. Please try again.');
    }
  };

  // In production, show loading while redirecting
  if (!isDevelopment) {
    return (
      <div className={styles.container}>
        <div className={styles.card}>
          <h1 className={styles.title}>SOPHIA</h1>
          <p className={styles.subtitle}>Learn. Invest. Change the world.</p>
          <div className={styles.loadingMessage}>
            Redirecting to login...
          </div>
        </div>
      </div>
    );
  }

  // Development: show email/password form
  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <h1 className={styles.title}>SOPHIA</h1>
        <p className={styles.subtitle}>Learn. Invest. Change the world.</p>

        <form onSubmit={handleSubmit} className={styles.form}>
          <div className={styles.inputGroup}>
            <label htmlFor="email" className={styles.label}>
              Email Address
            </label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              className={styles.input}
              disabled={isLoading}
              autoComplete="email"
            />
          </div>

          <div className={styles.inputGroup}>
            <label htmlFor="password" className={styles.label}>
              Password
            </label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              className={styles.input}
              disabled={isLoading}
              autoComplete="current-password"
            />
          </div>

          {error && (
            <div className={styles.error}>
              <strong>⚠️ Login Failed</strong>
              <br />
              {error}
            </div>
          )}

          <button
            type="submit"
            className={styles.button}
            disabled={isLoading}
          >
            {isLoading ? 'Connecting...' : 'Login'}
          </button>
        </form>

        <p className={styles.helpText}>
          Use your course credentials
        </p>

        <a
          href={`https://${process.env.REACT_APP_THINKIFIC_SUBDOMAIN}.thinkific.com/users/password/new`}
          className={styles.forgotPassword}
          target="_blank"
          rel="noopener noreferrer"
        >
          Forgot password?
        </a>
      </div>
    </div>
  );
}

export default LoginForm;
